<template>
<div>
    <el-row>
        <el-select v-if="usage == 'universityTutorial'" @change="getListData()" placeholder="学期" v-model="searchCondition.termId" size="medium">
            <el-option v-for="item in termList" :key="item.Id" :label="item.DisplayLable" :value="item.Id">
            </el-option>
        </el-select>
        <el-select v-if="usage == 'universityTutorial'" filterable @change="getListData()" placeholder="请选择" size="medium" v-model="searchCondition.groupNumber" class="margin-left-20px">
            <el-option v-for="item in universityGroups" :key="item.IdValue" :label="item.NameValue" :value="item.GroupNumber">
            </el-option>
        </el-select>
        <span v-if="usage == 'universityTutorial'" class="current-term">本学期：{{currentTerm.DisplayLable}}</span>

        <el-select v-if="usage == 'vocationalTraining'" @change="changeCourseCategory()" placeholder="职业类型" size="medium" v-model="vocationalTrainingSearchCondition.courseCategory">
            <el-option v-for="item in courseCategories" :key="item.Id" :label="item.Name" :value="item.Id">
            </el-option>
        </el-select>
        <el-select v-if="usage == 'vocationalTraining'" @change="getVocationalTrainingListData()" placeholder="学期" v-model="vocationalTrainingSearchCondition.termId" size="medium" class="margin-left-20px">
            <el-option v-for="item in vocationalTrainingTermList" :key="item.Id" :label="item.DisplayLable" :value="item.Id">
            </el-option>
        </el-select>
    </el-row>
    <pagination v-if="usage == 'universityTutorial'" v-loading="loading" :data="signInListData" :option="paginationOption" @edit="edit" @additional="onAdditional"></pagination>
    <pagination v-if="usage == 'vocationalTraining'" v-loading="loading" :data="vocationalTrainingSignInListData" :option="vocationalTrainingPaginationOption" @edit="editVocationalTraining" @additional="onAdditionalTraining"></pagination>
    <el-dialog title="学生分配" :center="true" :close-on-click-modal="false" width="700px" :visible.sync="reassignDialogVisible" top="8vh">
      <signInReassign :dataIn="reassignData" @close="onCloseReassignDialog" @saveSuccess="onReassignSaveSuccess"></signInReassign>
    </el-dialog>
</div>
</template>

<style lang="scss">
.current-term {
    padding-left: 20px;
}
</style>

<script>
import {
    getUniversityGroups,
    getUniversityByGroup,
    getTerms,
    getTrainingCategoryList,
    getTrainingTerms
} from "../../service/common.service";
import pagination from "../common/pagination";
import global_ from "@/core/global";
import signInReassign from "./signInReassign";
import {
    getUniversitySignInList, 
    getVocationalTrainingSignInList,
    recoverReassignSignIn
} from "../../service/signInManage.service";
// import {
//     getCurrentTerm
// } from "../../service/speedupCourse.service";

export default {
    data() {
        return {
            reassignDialogVisible: false,
            loading: false,
            listData: [],
            signInListData: [],
            paginationOption: {},
            universityGroups: [],
            searchCondition: {
                groupNumber: "",
                termId:""
            },
            
            currentTerm: {},
            termList: [],

            vocationalTrainingSignInListData: [],
            vocationalTrainingPaginationOption: [],
            vocationalTrainingSearchCondition: {
                courseCategory: "",
                termId:""
            },
            courseCategories: [],
            vocationalTrainingTermList: [],
            reassignData:{
                universityGroupNumber: 0,
                termId: 0,
                categoryId: 0,
                courseType: 0,
                courseId: 0,
                teacherId: 0,
                campusId: 0,
                courseName: "",
                teacherName: "",
                campusName: ""
            },
            isInit: true
        };
    },
    components: {
        pagination,
        signInReassign
    },
    props: ["usage"],
    created() {
        let additionalColumns = [];
        if (this.USERMANAGER.isAdmin || this.USERMANAGER.isAcademicDirector){
            additionalColumns.push({
                name:'reassignSignIn',
                title:'重新分配',
                buttonText:'分配'
            });
            additionalColumns.push({
                name:'recoverReassignSignIn',
                title:'恢复签到',
                buttonText:'恢复'
            });
        }
        this.paginationOption = {
            displayPagination: false,
            hasEditButton: true,
            editButtonText: "查看",
            hasAddButton: false,
            addButtonText: "",
            hasSearch: false,
            editColumnTite: "签到查看",
            showAcitveColor: true,
            hideDisableRow: true,
            additionalColumns: additionalColumns
        };

        this.vocationalTrainingPaginationOption = {
            displayPagination: false,
            hasEditButton: true,
            editButtonText: "查看",
            hasAddButton: false,
            addButtonText: "",
            hasSearch: false,
            editColumnTite: "签到查看",
            showAcitveColor: true,
            hideDisableRow: true,
        }
        
        if (this.usage === "universityTutorial"){
            this.loadUniversityGroups(()=>{
                this.setGroupNumber();
                this.getListData();
            });
            
            getTerms(false).then(result => {
                if (!!result && result.success) {
                    this.termList = result.data;
                    this.setTerm();
                    this.getListData();
                }
            });   
        }else{  
            getTrainingCategoryList(3).then(result => {
                if (!!result && result.success) {
                    this.courseCategories = result.data;
                    this.setCourseCategory();
                    this.changeCourseCategory();
                }
            });
        }
    },
    methods: {
        onCloseReassignDialog(){
            this.reassignDialogVisible = false;
        },
        onReassignSaveSuccess(){
            if (this.reassignData.courseType == 3){
                this.getVocationalTrainingListData();
            }else{
                this.getListData();
            }
        },
        setTerm(){
            let termId = this.$route.query.termId;
            if (termId){
                termId = parseInt(termId);
            }
            if (this.usage == 'universityTutorial'){
                if (termId && this.isInit && this.$route.query.usage === this.usage){
                    this.searchCondition.termId = termId;
                    this.isInit = false;
                }else{
                    let currentTerm = this.termList.filter(i => i.IsCurrentTerm);
                    if (currentTerm && currentTerm.length > 0) {
                        this.currentTerm = currentTerm[0];
                        this.searchCondition.termId = this.currentTerm.Id;
                    }
                }
            }else{
                if (termId && this.isInit && this.$route.query.usage === this.usage){
                    this.vocationalTrainingSearchCondition.termId = termId;
                    this.isInit = false;
                }else{
                    let currentTerm = this.vocationalTrainingTermList.find(i => i.IsCurrentTerm);
                    if (!!currentTerm) {
                        this.vocationalTrainingSearchCondition.termId = currentTerm.Id;
                    }else if (this.vocationalTrainingTermList.length > 0){
                        this.vocationalTrainingSearchCondition.termId = this.vocationalTrainingTermList[0].Id;
                    }else{
                        this.vocationalTrainingSearchCondition.termId = "";
                    }
                }
            }
        },
        setGroupNumber(){
            let groupNumber = this.$route.query.groupNumber;
            if (groupNumber){
                groupNumber = parseInt(groupNumber);
            }
            if (groupNumber) {
                this.searchCondition.groupNumber = groupNumber;
            }else{
                if (!!this.universityGroups && this.universityGroups.length > 0){
                    this.searchCondition.groupNumber = this.universityGroups[0].GroupNumber;
                }
            }
        },
        setCourseCategory(){
            let courseCategory = this.$route.query.courseCategory;
            if (courseCategory){
                courseCategory = parseInt(courseCategory);
            }
            if (courseCategory) {
                this.vocationalTrainingSearchCondition.courseCategory = courseCategory;
            }else{
                if (!!this.courseCategories && this.courseCategories.length > 0){
                    this.vocationalTrainingSearchCondition.courseCategory = this.courseCategories[0].Id;
                }
            }
        },
        loadUniversityGroups(callback) {
            getUniversityGroups(false, true).then(result => {
                if (!!result && result.success) {
                    this.universityGroups = result.data;
                    if (!!callback){
                        callback();
                    }
                }
            });
        },
        getListData() {
            if (!this.searchCondition.groupNumber || !this.searchCondition.termId)
                return;

            this.loading = true;
            getUniversitySignInList(this.searchCondition.groupNumber, this.searchCondition.termId).then(result => {
                if (!!result && result.success) {
                    this.signInListData = result.data;
                }
                this.loading = false;
            });
        },
        onAdditional(name, index, row){
            if (name == 'reassignSignIn'){
                this.reassignData = {
                    universityGroupNumber: this.searchCondition.groupNumber,
                    termId: this.searchCondition.termId,
                    categoryId: 0,
                    courseType: 1,
                    courseId: row.CourseId,
                    teacherId: row.TeacherId,
                    campusId: 0,
                    courseName: row.CourseName,
                    teacherName: row.TeacherName,
                    campusName: row.CampusName,
                };
                this.reassignDialogVisible = true;
            }else if(name == 'recoverReassignSignIn'){
                this.$confirm("您确定要恢复课程"+row.CourseName+"的签到记录吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                    }).then(() => {
                        this.loading = true;
                        recoverReassignSignIn(row.CourseId, row.TeacherId).then(result => {
                            
                            if (result.success && result.data) {
                                this.$message({
                                    message: "恢复课程签到成功",
                                    type: "success"
                                });
                                this.getListData();
                            } else {
                                this.$message({
                                    message: "恢复课程签到失败",
                                    type: "error"
                                });
                            }
                            this.loading = false;
                        });
                    })
                    .catch(()=>{
                        this.loading = false;
                    });
            }
        },
        onAdditionalTraining(index, row){
            this.reassignData = {
                universityGroupNumber: 0,
                termId: 0,
                categoryId: 0,
                courseType: 0,
                courseId: row.CourseId,
                teacherId: row.TeacherId,
                campusId: row.CampusId,
                courseName: row.CourseName,
                teacherName: row.TeacherName,
                campusName: row.CampusName,
            };
            this.reassignDialogVisible = true;
        },
        edit(index, row) {
            this.$router.push({
                path: "/admin/signInManageEdit",
                query: {
                    back: 'signInManage',
                    groupNumber: this.searchCondition.groupNumber,
                    termId: this.searchCondition.termId,
                    teacherId: row.TeacherId,
                    courseId: row.CourseId,
                    courseName: row.CourseName,
                    teacherName: row.TeacherName,
                    status: row.Active,
                    usage: 'universityTutorial'
                }
            });
        },
        changeCourseCategory() {
            getTrainingTerms(false, this.vocationalTrainingSearchCondition.courseCategory).then(result => {
                if (!!result && result.success) {
                    this.vocationalTrainingTermList = result.data;
                    this.setTerm();
                    this.getVocationalTrainingListData();
                }
            });
        },
        getVocationalTrainingListData() {
            if (!this.vocationalTrainingSearchCondition.courseCategory || !this.vocationalTrainingSearchCondition.termId)
                return;

            this.loading = true;
            getVocationalTrainingSignInList(this.vocationalTrainingSearchCondition.courseCategory, this.vocationalTrainingSearchCondition.termId).then(result => {
                if (!!result && result.success) {
                    this.vocationalTrainingSignInListData = result.data;
                }
                this.loading = false;
            });
        },
        editVocationalTraining(index, row) {
            this.$router.push({
                path: "/admin/signInManageEdit",
                query: {
                    back: 'signInManage',
                    courseCategory: this.vocationalTrainingSearchCondition.courseCategory,
                    termId: this.vocationalTrainingSearchCondition.termId,
                    teacherId: row.TeacherId,
                    courseId: row.CourseId,
                    campusId: row.CampusId,
                    courseName: row.CourseName,
                    teacherName: row.TeacherName,
                    campusName: row.CampusName,
                    status: row.Active,
                    usage: 'vocationalTraining'
                }
            });
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/signInManage/signInManageList.vue